window.initCustomMaps = async function () {
    const mapContainers = document.querySelectorAll('.map-section__map');
    if (!mapContainers.length) return;

    const { Map } = await google.maps.importLibrary("maps");
    // const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    // JSON style
    const snazzyStyles = [
        {"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},
        {"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},
        {"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},
        {"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},
        {"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},
        {"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},
        {"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},
        {"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},
        {"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},
        {"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},
        {"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}
    ];

    mapContainers.forEach(function(el) {
        const markerEl = el.querySelector('.map-section__marker');
        if (!markerEl) return;

        const lat = parseFloat(markerEl.getAttribute('data-lat'));
        const lng = parseFloat(markerEl.getAttribute('data-lng'));
        const zoom = parseInt(el.getAttribute('data-zoom')) || 14;
        const position = { lat: lat, lng: lng };

        const map = new Map(el, {
            zoom: zoom,
            center: position,
            styles: snazzyStyles,
            disableDefaultUI: true,
            zoomControl: true,
            scrollwheel: false
        });

        new google.maps.Marker({
            position: position,
            map: map,
            title: "Location name"
        });

        // A new way to create a marker
        // new AdvancedMarkerElement({
        //     map: map,
        //     position: position,
        //     title: "Location name"
        // });
    });
};